// import {load} from '@shopify/theme-sections';
import AccordionList from '../components/accordion-list';
import 'nodelist-foreach-polyfill';

const components = {
  AccordionList,
};

// Instantiate components automatically
document.querySelectorAll('[data-component]').forEach(el => {
  if (components[el.dataset.component]) {
    new components[el.dataset.component](el);
  } else {
    console.error(el.dataset.component, 'component is not defined.');
  }
});
